import * as grupos from '@/api/grupo'
import { convertSelect } from '../../../service/collection'

const state = {
  lista: [],
  listaSelect: []
}

const mutations = {
  SETGRUPOSSELECT (state, payload) {
    state.listaSelect = convertSelect(payload.list)
  }
}

const actions = {
  async getGruposSelect ({ commit }, payload) {
    let data = await grupos.listSelect(payload)
    commit('SETGRUPOSSELECT', data)
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/gerenciador/grupo.js